import tw from 'twin.macro';

export const MarketingButton = tw.button`bg-[#34AC80]  hover:bg-[#3dcc9a] font-medium rounded-full py-3 px-6 md:px-10  text-sm md:text-base text-black hover:cursor-pointer hover:scale-[102.5%] transition-all`;
